import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("CARGAR_SERVICIO", newActions, newReducers);

const cargarServicioThunk = (data) => {
  const url = `${baseUrl}/servicio`;
  return createThunk(axios, "post", duck.actions, url, data);
};

const duckEditServicio = createDuck("EDITAR_SERVICIO", newActions, newReducers);

const editServicioThunk = (data) => {
  const url = `${baseUrl}/servicio`;
  return createThunk(axios, "patch", duckEditServicio.actions, url, data);
};

const duckProfesionalesForSelect = createDuck("PROFESIONALES_OPTIONS", newActions, newReducers);

const profesionalesForSelectThunk = (id, ambientes=false) => {
  let url = null;
  if(ambientes){
    url = `${baseUrl}/profesionalesForSelect/${id}?ambientes=${true}`;
  }
  else{
    url = `${baseUrl}/profesionalesForSelect/${id}`;
  }


  return createThunk(axios, "get", duckProfesionalesForSelect.actions, url, null);
};

const duckServiciosPadreAsOptions = createDuck("GET_SERVICIOS_PADRE_AS_OPTIONS", newActions, newReducers);

const serviciosPadreAsOptionsThunk = (id) => {
  const url = `${baseUrl}/serviciosPadreAsOptions/${id}`;
  return createThunk(axios, "get", duckServiciosPadreAsOptions.actions, url, null);
};

const duckServiciosById = createDuck("SERVICIOS_BY_ID", newActions, newReducers);

const servicioByIdThunk = (id) => {
  const url = `${baseUrl}/servicioById/${id}`;
  return createThunk(axios, "get", duckServiciosById.actions, url, null);
};

const duckEliminarImgServicio = createDuck("ELIMINAR_IMG_SERVICIO", newActions, newReducers);

const eliminarImgServicioThunk = (data) => {
  const url = `${baseUrl}/eliminarImgServicio`;
  return createThunk(axios, "post", duckEliminarImgServicio.actions, url, data);
};

const duckUpdateSubcategoria = createDuck("UPDATE_SUBCATEGORIA", newActions, newReducers);

const updateSubcategoriaThunk = (data) => {
  const url = `${baseUrl}/updateSubcategoria`;
  return createThunk(axios, "post", duckUpdateSubcategoria.actions, url, data);
};

const duckDeleteSubcategoria = createDuck("DELETE_SUBCATEGORIA", newActions, newReducers);

const deleteSubcategoriaThunk = (data) => {

  const url = `${baseUrl}/deleteSubcategoria`;
  return createThunk(axios, "post", duckDeleteSubcategoria.actions, url, data);
};

const duckDeleteServicio = createDuck("DELETE_SERVICIO", newActions, newReducers);

const deleteServicioThunk = (data) => {

  const url = `${baseUrl}/deleteServicio`;
  return createThunk(axios, "post", duckDeleteServicio.actions, url, data);
};
export default {
  duck,
  cargarServicioThunk,
  duckEditServicio,
  editServicioThunk,
  duckProfesionalesForSelect,
  profesionalesForSelectThunk,
  duckServiciosPadreAsOptions,
  serviciosPadreAsOptionsThunk,
  duckServiciosById,
  servicioByIdThunk,
  duckEliminarImgServicio,
  eliminarImgServicioThunk,
  duckUpdateSubcategoria,
  updateSubcategoriaThunk,
  duckDeleteSubcategoria,
  deleteSubcategoriaThunk,
  duckDeleteServicio,
  deleteServicioThunk,
};
